import { useCallback } from 'react'

import { useSegment } from '../../../hooks'
import { useOnboardingSetupContext } from '../contexts/OnboardingSetupContext'
import { OnboardingSetupStep } from '../types/onboardingSetupStep'

const stepAnalyticsNames: Partial<Record<OnboardingSetupStep, string>> = {
  ACCOUNTING_MANAGEMENT: 'Accounting Management',
  INTENT: 'Intent',
  INVOICES: 'Company Info',
  NAME_PHONE: 'About You',
  WORK_STYLE: 'Work Style',
}

export const useTrackOnboarding = () => {
  const { track } = useSegment()
  const { currentStep } = useOnboardingSetupContext()

  const trackOnboarding = useCallback(
    (event: string, payload?: Record<string, unknown>) => {
      const stepName = currentStep ? stepAnalyticsNames[currentStep] : undefined
      if (!stepName) {
        return
      }

      track(`XXX - AG - Onboarding ${stepName} - ${event}`, payload)
    },
    [currentStep, track],
  )

  return { trackOnboarding }
}
